import { useState } from "react";
import { toast } from "react-toastify";
import createFeature from "../function/createFeature";
import { Switch } from 'antd';
import { createAdvancedFeature } from "../function/createAdvancedFeature";

const AddFeaturesModal = ({ onClose }: { onClose: () => void; }) => {
    const [addFeatureName, setAddFeatureName] = useState('');
    const [addFeatureDescription, setAddFeatureDescription] = useState('');
    const [addFeatureKey, setAddFeatureKey] = useState('');
    const [addFeatureValue, setAddFeatureValue] = useState(0);
    const [advancedOptions, setAdvancedOptions] = useState(false);


    function checkData() {
        if (!addFeatureName) {
            toast.error("Feature name is required");
            return false;
        }
        if (!addFeatureDescription) {
            toast.error("Feature description is required");
            return false;
        }
        return true;
    }

    async function handleAddFeature() {
        if (!checkData()) return;
        if (advancedOptions) {
            const newFeatureID = await createAdvancedFeature({
                name: addFeatureName,
                description: addFeatureDescription,
                key: addFeatureKey || undefined,
                number: addFeatureValue || undefined
            });
            if (newFeatureID) {
                toast.success("Feature added successfully");
                onClose();
            } else {
                toast.error("Failed to add feature");
            }
        }
        else {
            const newFeatureID = await createFeature({
                name: addFeatureName,
                description: addFeatureDescription,
            });
            if (newFeatureID) {
                toast.success("Feature added successfully");
                onClose();
            } else {
                toast.error("Failed to add feature");
            }
        }
    }
    return (
        <div className="px-2 py-4 flex flex-col gap-4">
            <div className="flex flex-col gap-4">
                <div className="flex flex-col gap-2">
                    <label htmlFor="featureName" className="font-medium">Feature Name</label>
                    <input
                        value={addFeatureName}
                        onChange={(e) => setAddFeatureName(e.target.value)}
                        type="text" id="featureName" className="border p-2 rounded-lg w-full" placeholder="Enter feature name" />
                </div>
                <div className="flex flex-col gap-2">
                    <label htmlFor="featureDescription" className="font-medium">Feature Description</label>
                    <textarea
                        value={addFeatureDescription}
                        onChange={(e) => setAddFeatureDescription(e.target.value)}
                        id="featureDescription" className="min-h-[200px] border p-2 rounded-lg w-full" placeholder="Enter feature description"></textarea>
                </div>
                <div className="flex items-center gap-2">
                    <Switch onChange={() => setAdvancedOptions(!advancedOptions)} /> Enable Advanced Options
                </div>
                {/* Advanced Options */}
                {
                    advancedOptions && (
                        <div className="flex flex-col gap-4">
                            <div className="flex flex-col gap-2">
                                <label htmlFor="featureKey" className="font-medium">Feature Key (Optional)</label>
                                <input
                                    value={addFeatureKey}
                                    onChange={(e) => setAddFeatureKey(e.target.value)}
                                    type="text" id="featureKey" className="border p-2 rounded-lg w-full" placeholder="Enter feature key" />
                            </div>
                            <div className="flex flex-col gap-2">
                                <label htmlFor="featureValue" className="font-medium">Feature Value (Optional)</label>
                                <input
                                    value={addFeatureValue}
                                    onChange={(e) => setAddFeatureValue(Number(e.target.value))}
                                    type="number" id="featureValue" className="border p-2 rounded-lg w-full" placeholder="Enter feature value" />
                            </div>
                        </div>
                    )
                }
                {/* End Advanced Options */}
                <div className="flex justify-end gap-4 mt-4">
                    <button onClick={onClose} className="px-4 py-2 rounded-lg bg-gray-300 hover:bg-gray-400 transition-colors">
                        Cancel
                    </button>
                    <button
                        onClick={handleAddFeature}
                        className="px-4 py-2 rounded-lg bg-blue-600 !text-white hover:bg-blue-700 transition-colors">
                        Add Feature
                    </button>
                </div>
            </div>
        </div>
    )
}

export default AddFeaturesModal;